import "./SectionHeader.css";

type SectionHeaderProps = {
  title: string;
  style?: any;
};
const SectionHeader = ({ title, style }: SectionHeaderProps) => {
  return (
    <div className="sectionHeader_container" style={style}>
      <p>{title}</p>
    </div>
  );
};

export default SectionHeader;
